import { ButtonLight, Box, Modal } from 'front-end/src/components'
import { t, Trans } from '@lingui/macro'
import { UnorderedList, ListItem, UseDisclosureReturn } from '@chakra-ui/react'
import React from 'react'
import { useManageEventContext } from '../../../ManageEventContext'

type ExportInviteesModalProps = {
  disclosure: UseDisclosureReturn
}

export const ExportInviteesModal: React.FC<ExportInviteesModalProps> = ({
  disclosure,
  children
}) => {
  const { isRecurringSeries } = useManageEventContext()

  const { isOpen, onClose } = disclosure

  return (
    <Modal
      show={isOpen}
      newDesign
      header={
        isRecurringSeries
          ? t`Export series data to CSV file`
          : t`Export data to CSV file`
      }
      controls={[
        <ButtonLight onClick={onClose} key={1}>
          <Trans>Cancel</Trans>
        </ButtonLight>,
        children
      ]}
    >
      {isRecurringSeries && (
        <Box>
          <Trans>
            This export will contain information about all occurrences in the
            event series
            <UnorderedList pl="8px">
              <ListItem>
                <strong>RSVP and attendance</strong> of all invitees
              </ListItem>
              <ListItem>
                <strong>Descriptive data</strong> of all event occurrences
              </ListItem>
            </UnorderedList>
          </Trans>
        </Box>
      )}
    </Modal>
  )
}
